import React, { useEffect, useMemo, useState } from "react";
import SimpleBar from "simplebar-react";
import { Alert, Card, CardBody, Col, Spinner } from "reactstrap";
import { getDashboardCaptureTotalsByValuer } from "../../services/ValitanApiService";

const MAX_VALUERS = 8;

const Capturing = () => {
  const [valuers, setValuers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadCaptureSummary = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await getDashboardCaptureTotalsByValuer();
        const payload = response?.data?.data || {};
        const items = Array.isArray(payload?.valuers) ? payload.valuers : [];
        if (!isMounted) return;
        setValuers(items);
      } catch (err) {
        if (!isMounted) return;
        console.error("Error loading capture summary:", err);
        setError("Failed to load capture summary.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadCaptureSummary();
    return () => {
      isMounted = false;
    };
  }, []);

  const captureSummary = useMemo(
    () =>
      valuers
        .map((item, index) => ({
          key: item?.valuerId || item?.valuer_id || item?.valuerName || `valuer-${index}`,
          name: item?.valuerName || item?.valuer_name || "Unknown Valuer",
          total: item?.assetCount || item?.asset_count || 0,
        }))
        .filter((item) => item.total > 0)
        .slice(0, MAX_VALUERS),
    [valuers]
  );

  return (
    <Col md={12} lg={4}>
      <Card className="dashboard-widget">
        <CardBody>
          <div className="widget-header">
            <div>
              <h5 className="widget-title">Capturing</h5>
              <p className="widget-copy">Asset capturing totals by Valuer.</p>
            </div>
            <div className="widget-chip">Captured</div>
          </div>

          {loading ? (
            <div className="py-4 text-center">
              <Spinner size="sm" color="primary" />
            </div>
          ) : error ? (
            <Alert color="danger" className="mb-0">
              {error}
            </Alert>
          ) : captureSummary.length === 0 ? (
            <Alert color="light" className="mb-0">
              No captured assets found.
            </Alert>
          ) : (
            <div className="pe-1">
              <SimpleBar style={{ maxHeight: "287px" }}>
                <div className="notice-list">
                  {captureSummary.map((item) => (
                    <div key={item.key} className="notice-item">
                      <div className="flex-shrink-0">
                        <div className="notice-icon">
                          <span>
                            <i className="ri-folder-chart-line" />
                          </span>
                        </div>
                      </div>

                      <div className="flex-grow-1 overflow-hidden">
                        <div className="notice-title mb-1">{item.name}</div>
                        <div className="notice-copy text-truncate">Captured asset activity</div>
                      </div>
                      <div className="notice-time">{item.total}</div>
                    </div>
                  ))}
                </div>
              </SimpleBar>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Capturing;
